<template>
    <div class="container">
        <div class="background-image" :hour="$util.tool.dateTransform().hour"></div>
        <div class="login-content">
            <div class="back-shape"></div>
            <div class="login-form">
                <div class="login-title">锡盟燃气</div>
                <div class="form-content">
                    <div class="title">用户名</div>
                    <input type="text" v-model="username" placeholder="请输入用户名" />
                </div>
                <div class="form-content">
                    <div class="title"><span gap>密</span>码</div>
                    <input type="password" v-model="password" placeholder="请输入密码" />
                </div>
                <button class="login-button" @click="toLogin"><span gap>登</span>录</button>
            </div>
        </div>
        <div class="apk-qrcode">
            <div class="qrcode"></div>
            <div class="hint">扫一扫下载APP</div>
        </div>
    </div>
</template>

<script>
import {
    mapMutations
} from 'vuex'

export default {
    data() {
        return {
            username: '',
            password: ''
        }
    },
    created() {
        
    },
    props: {

    },
    watch: {

    },
    methods: {
        ...mapMutations('global', ['setMenuPermitted', 'setLoadingGlobal']),
        ...mapMutations('stored', ['setUserInfo']),
        async toLogin() {
            let res = await this.$util.request(this.$ctrl.login, {
                name: this.username,
                password: this.password
            })
            if (res.id && res.id > 0) {
                this.setUserInfo({
                    uid: res.id,
                    uname: this.username,
                    role: res.role_id,
                    stationId: res.status
                })
                this.$notification.success({
                    message: '登录成功',
                    description: `${this.username}, ${this.$util.tool.dateTransform().daily[1]}`
                })
            } else {
                this.$error({
                    title: '警告',
                    content: '登录失败，请检查账号密码是否有误！',
                    centered: true
                })
            }
        }
    }
}
</script>

<style scoped lang="less">
    @import './login.less';
</style>
